class LazyVideo extends HTMLElement {
  constructor() {
    super();
    this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
      rootMargin: '0px 0px 200px 0px'
    });
  }

  connectedCallback() {
    this.video = this.querySelector('video');
    if (!this.video) return;
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer.disconnect();
  }

  handleIntersection(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (this.video.paused) {
          const playPromise = this.video.play();
          if (playPromise !== undefined) {
            playPromise.catch(error => {
              // Auto-play was prevented or video is not ready
            });
          }
        }
      } else {
        if (!this.video.paused) {
          this.video.pause();
        }
      }
    });
  }
}
customElements.define('lazy-video', LazyVideo);
